import { Banner, Link } from "@components/ui-kit";
import { Trans, t } from "@lingui/macro";
import { useEffect, useRef } from "react";
import { useToggle } from "react-use";

interface DuplicateExpensesBannerProps {
  expenseIds: string[];
}

export const DuplicateExpensesBanner = (
  props: DuplicateExpensesBannerProps,
) => {
  const bannerRef = useRef<HTMLDivElement>(null);
  const [show, toggleShow] = useToggle(true);

  useEffect(() => bannerRef.current?.focus(), []);

  if (!show) {
    return null;
  }

  return (
    <div ref={bannerRef}>
      <Banner
        title={t`This expense already exists`}
        status="error"
        dismissAction={{ onClick: toggleShow }}
        description={
          <p>
            <Trans>This is duplicate of expense</Trans>
            {props.expenseIds.map((i) => (
              <span key={i}>
                {" "}
                <Link href={{ pathname: "/expenses/edit", query: { id: i } }}>
                  {i}
                </Link>
              </span>
            ))}
          </p>
        }
      />
    </div>
  );
};
